import axios from "../utils/axios";

export const getAllLevels = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/levels', { params });
    return data;
};

export const getLevelsForSelect = async () => {
    const { data } = await axios.get('/levels/for-select');
    return data;
};

export const getLevel = async (id) => {
    const { data } = await axios.get(`/levels/${id}`);
    return data;
};

export const createLevel = async (req) => {
    const { data } = await axios.post('/levels', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const updateLevel = async (req, id) => {
    const { data } = await axios.put(`/levels/${id}`, req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteLevel = async (id) => {
    const { data } = await axios.delete(`/levels/${id}`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteAllLevels = async (req) => {
    const { data } = await axios.delete('/levels/mass-destroy', {
        data: req,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteLevel = async (id) => {
    const { data } = await axios.delete(`/levels/${id}/force-delete`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteAllLevels = async (ids) => {
    const { data } = await axios.delete('/levels/mass-force-delete', {
        data: ids,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreLevel = async (id) => {
    const { data } = await axios.post(`/levels/${id}/restore`, {}, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreAllLevels = async (req) => {
    const { data } = await axios.post('/levels/mass-restore', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};
